import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Icon, type IconName} from '@wandb/weave/components/Icon';
import {clsx} from 'clsx';
import copyToClipboard from 'copy-to-clipboard';
import React from 'react';

interface CopyableTextProps {
  className?: string;
  dataTest?: string;
  text: string;
  copyText?: string;
  toastText: string;
  icon?: IconName;
  code?: boolean;
  disabled?: boolean;
  onClick?(): void;
}

const CopyableText: React.FC<CopyableTextProps> = ({
  className,
  dataTest,
  text,
  copyText,
  toastText,
  icon,
  code,
  disabled,
  onClick,
}) => {
  const copy = () => {
    copyToClipboard(copyText ?? text);
    toast(toastText);
  };

  return (
    <span
      className={clsx('copyable-text', className, {code, disabled})}
      data-test={dataTest}
      onClick={e => {
        e.stopPropagation();
        if (disabled) {
          return;
        }
        copy();
        onClick?.();
      }}>
      <span className="copyable-text-content">{text}</span>
      <Icon className="copy-icon" name={icon ?? 'copy'} />
    </span>
  );
};
CopyableText.displayName = 'CopyableText';

export default CopyableText;
